// extracted by mini-css-extract-plugin
export var addToCartButton = "_om-b";
export var arrowButtonContainer = "_om-9";
export var arrowButtonIcon = "_om-a";
export var carouselArrowButton = "_om-6";
export var carouselElementContainer = "_om-1";
export var galleryThumbnail = "_om-d";
export var galleryThumbnailImage = "_om-e";
export var left = "_om-7";
export var productDisplayCarouselContainer = "_om-0";
export var productTileContainer = "_om-2";
export var productTileImage = "_om-4";
export var productTileImageContainer = "_om-3";
export var productTileTitle = "_om-5";
export var right = "_om-8";
export var sliderOverflow = "_om-c";